'use strict';

module Patersons {

    export interface UserProfile {
        given_name: string;
        family_name: string;
        email: string;
    }

    export class SessionService {
        tokenService: TokenService;
        modalInstance: any;
        modalStack: any;
        openModal :any;
        sessionTimeoutHandler = null
        sessionPreTimeoutHandler = null
        sessionTimeoutKey = '$psl.sessionTimeout'
        $analytics;
        static $inject = ['tokenService', '$rootScope', '$uibModal', '$uibModalStack', '$analytics'];

        constructor(tokenService, $rootScope, $uibModal, $uibModalStack,$analytics) {
            this.tokenService = tokenService;
            this.modalInstance = $uibModal;
            this.modalStack = $uibModalStack;
            this.$analytics = $analytics;
            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
                const session = this.checkSession()
                // if (!session) {
                //     event.preventDefault();
                //     return;
                // }
            })
        }
        setSessionExpiringModal() {
            this.modalStack.dismissAll()
            this.openModal = this.modalInstance.open({

                templateUrl: 'assets/templates/common/sessionTimeoutModal.html',
                size: 'sm',
                controller: SessionTimeoutModalCtrl,
                keyboard: false,
                backdrop: 'static',
                openedClass: 'timeout-modal',
                resolve: {
                    currentState: function () { return 'expiring' }
                }
            }).result.then((result) => {
                if(result == 'yes'){
                    this.checkSession();
                }
            })
        }
        setSessionExpiredModal(){
            this.modalStack.dismissAll()
            this.openModal = this.modalInstance.open({

                templateUrl: 'assets/templates/common/sessionTimeoutModal.html',
                size: 'sm',
                controller: SessionTimeoutModalCtrl,
                keyboard: false,
                backdrop: 'static',
                openedClass: 'timeout-modal',
                resolve: {
                    currentState: function() { return 'expired' }
                }
            }).result.then((result) => {
                if(result =='ok'){
                    this.handleSessionTimedout()
                }
            })
        }
        checkSession() {
            console.log('checking timeout')
            const sessionTimeoutExists = localStorage.getItem(this.sessionTimeoutKey);
            const now = new Date();
            const timeout = new Date(+sessionTimeoutExists)
            const isLoggedIn = this.isLoggedIn();
            const timeoutInMinutes = 20;
            clearTimeout(this.sessionTimeoutHandler);
            clearTimeout(this.sessionPreTimeoutHandler);

            if (isLoggedIn) {
                if ((now > timeout) && sessionTimeoutExists) {
                    console.log('timedout')
                    //need to log user out here
                    this.setSessionExpiredModal();
                    return false;
                } else {
                    const timeout = now.getTime() + (timeoutInMinutes * 60 * 1000) // add x minutes
                    console.log('extending session')
                    localStorage.setItem(this.sessionTimeoutKey, timeout.toString())

                    this.sessionPreTimeoutHandler = setTimeout(() => {
                        console.log("Timeout is coming up")
                        this.setSessionExpiringModal()
                    }, (timeout - (1 * 60 * 1000)) - now.getTime()) // 1 minute before

                    this.sessionTimeoutHandler = setTimeout(() => {
                        console.log("Timeout is past")
                        this.setSessionExpiredModal()
                    }, (timeout) - now.getTime()) // timeout has passed
                    return true;
                }
            } else {
                localStorage.removeItem(this.sessionTimeoutKey)
                return true;
            }
        }
        handleSessionTimedout (){
            window.stop();
            localStorage.removeItem(this.sessionTimeoutKey)
            this.$analytics.eventTrack('Logout Session Timed Out', {
                category: 'Logout'
            });
            window.location = "/identity/connect/endsession" as any;
            // this.tokenService.tokenManager.redirectForLogout();
            return false;

        }
        login(): void {
            window.localStorage.setItem('$psl.redirect_uri', window.location.href);
            this.tokenService.tokenManager.redirectForToken();
        }

        logout(): void {
            this.$analytics.eventTrack('Logout Success', {
                category: 'Logout'
            });

            this.tokenService.tokenManager.removeToken();
            window.location = "/identity/connect/endsession" as any;
            // this.tokenService.tokenManager.redirectForLogout();
        }

        isLoggedIn(): boolean {
            return this.tokenService.tokenManager && !this.tokenService.tokenManager.expired;
        }

        getCurrentUserProfile(): UserProfile {
            if(this.isLoggedIn()){
                return this.tokenService.tokenManager.profile;
            }else{
                this.login();
            }
        }
    }
}
